import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const heroRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  // Animations removed for stability

  const redirectToDashboard = () => {
    if (
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user") || "{}").access_token
    ) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  return (
    <section
      className="hero relative flex items-center justify-center pt-20 pb-10 px-5 text-white text-center overflow-hidden h-screen max-h-[1280px]"
      ref={heroRef}
    >
      {/* Subtle static background visuals */}
      <div
        aria-hidden
        className="absolute -top-28 -left-28 w-[520px] h-[520px] opacity-50 blur-[60px] z-0 bg-[radial-gradient(closest-side,rgba(99,102,241,0.55),rgba(99,102,241,0))]"
      />
      <div
        aria-hidden
        className="absolute inset-x-[-20%] top-[40%] h-[250%] z-0 blur-[2px] bg-[radial-gradient(75%_65%_at_50%_50%,rgba(99,102,241,0.30),rgba(99,102,241,0)_45%),radial-gradient(70%_60%_at_60%_50%,rgba(14,165,233,0.22),rgba(14,165,233,0)_60%),radial-gradient(70%_60%_at_40%_60%,rgba(20,184,166,0.10),rgba(20,184,166,0)_65%)]"
      />
      <div
        aria-hidden
        className="absolute -bottom-24 -right-24 w-[360px] h-[360px] opacity-40 blur-[50px] bg-[radial-gradient(closest-side,rgba(14,165,233,0.5),rgba(14,165,233,0))]"
      />

      <div className="relative z-10 max-w-[980px] mx-auto">
        <h1 className="font-extrabold tracking-tight mb-4 leading-[1.05] text-[clamp(2.5rem,6vw,4.5rem)]">
          <span>Budget Like a Boss,</span>
          <br />
          <span className="bg-gradient-to-r from-gray-200 via-white to-indigo-300 bg-clip-text text-transparent">
            with Budiee.
          </span>
        </h1>
        <p className="text-[clamp(1.05rem,2.2vw,1.35rem)] text-white/90 max-w-[760px] mx-auto mb-7">
          Track expenses, plan goals, manage debts, and grow your wealth — all
          in one simple app.
        </p>
        <div className="inline-flex flex-col items-center gap-3">
          <div className="inline-flex items-center justify-center gap-3 flex-wrap">
            <button
              onClick={redirectToDashboard}
              className="hero-button btn-primary px-5 py-3"
            >
              Start Tracking Now
              <svg
                className="ml-2 inline-block align-[-2px]"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              onClick={() => navigate("/features")}
              className="hero-button btn-secondary px-5 py-3"
            >
              Explore Features
            </button>
          </div>

          <p className="mt-2 text-[0.92rem] text-white/80">
            Free forever on Basic. No card needed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
